/* Desktop mega menu on hover. The panels stay native <details>
   elements, so click, keyboard and the focusout close in
   details-disclosure.js keep working unchanged; this only adds pointer
   opening on top.

   Guarded by (hover: hover) and (pointer: fine) — touch and coarse
   pointers keep the click behaviour, where a hover menu would open on
   the first tap and swallow the second. The open/close delays absorb
   the diagonal travel from the summary down into the panel, and moving
   to a sibling closes the previous panel at once rather than waiting
   the close delay out. */
(() => {
  const OPEN_DELAY = 60;
  const CLOSE_DELAY = 200;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const panels = () => document.querySelectorAll('.header__inline-menu header-menu');

  const setOpen = (details, open) => {
    if (details.open === open) return;
    details.open = open;
    details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
  };

  const closeOthers = (keep) => {
    panels().forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details || details === keep) return;
      clearTimeout(menu.dataset.timerId);
      setOpen(details, false);
    });
  };

  const bind = (menu) => {
    const details = menu.querySelector('details');
    if (!details || menu.hoverBound) return;
    menu.hoverBound = true;

    let timer = null;
    const schedule = (open) => {
      clearTimeout(timer);
      timer = setTimeout(
        () => {
          if (open) closeOthers(details);
          setOpen(details, open);
        },
        open ? OPEN_DELAY : CLOSE_DELAY
      );
      menu.dataset.timerId = timer;
    };

    menu.addEventListener('mouseenter', () => canHover.matches && schedule(true));
    menu.addEventListener('mouseleave', () => canHover.matches && schedule(false));

    /* A mouse click on an already-hovered summary would toggle the panel
       shut under the pointer, and it would reopen the moment the pointer
       moved. Keyboard activation reports detail === 0 and still toggles,
       so Enter/Space keep closing the panel. */
    details.querySelector('summary').addEventListener('click', (event) => {
      if (canHover.matches && details.open && event.detail > 0) event.preventDefault();
    });
  };

  const init = () => panels().forEach(bind);

  init();
  document.addEventListener('shopify:section:load', init);
})();
